/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type DeleteSdkKeyByKeyPathParams = NonNullable<operations['deleteSdkKeyByKey']['parameters']['path']>;

export interface Input extends DeleteSdkKeyByKeyPathParams {
  apiVersion?: string;
  header: NonNullable<operations['deleteSdkKeyByKey']['parameters']['header']>;
}

export async function deleteSdkKeyByKey(
  { apiVersion, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().DELETE('/api/v2/projects/{projectKey}/environments/{environmentKey}/sdk-keys/{sdkKeyKey}', {
    params: { path, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
